import { withTranslation as withTranslationFunc } from 'react-i18next';
export const withTranslation = (component) => withTranslationFunc()(component);
//# sourceMappingURL=with-translation.js.map